export const FETCH_CARRIERS = 'FETCH_CARRIERS';
export const FETCH_CARRIERS_COUNT = 'FETCH_CARRIERS_COUNT';
export const ADD_CARRIERS_SUCCESS = 'ADD_CARRIERS_SUCCESS';
export const EDIT_CARRIERS_SUCCESS = 'EDIT_CARRIERS_SUCCESS';
